/**
 * HTTP headers and status codes.
 *
 * The master prompt forbids magic numbers; every status code the platform
 * returns is named here so no route ever writes a bare `404`.
 */
export const HEADERS = {
    /** Correlates every log line and downstream call for one logical operation. */
    CORRELATION_ID: 'x-correlation-id',
    /** Identifies a single inbound HTTP request. */
    REQUEST_ID: 'x-request-id',
    /** Client-supplied key making a mutating request safely replayable. */
    IDEMPOTENCY_KEY: 'idempotency-key',
    /** Claims the Gateway forwards to a trusted downstream service. */
    INTERNAL_CLAIMS: 'x-internal-claims',
    /** Signature proving the internal claims header came from the Gateway. */
    INTERNAL_SIGNATURE: 'x-internal-signature',
    AUTHORIZATION: 'authorization',
    CONTENT_TYPE: 'content-type',
    ACCEPT_LANGUAGE: 'accept-language',
    USER_AGENT: 'user-agent',
    FORWARDED_FOR: 'x-forwarded-for',
    RATE_LIMIT_LIMIT: 'ratelimit-limit',
    RATE_LIMIT_REMAINING: 'ratelimit-remaining',
    RATE_LIMIT_RESET: 'ratelimit-reset',
    RETRY_AFTER: 'retry-after',
};
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    MOVED_PERMANENTLY: 301,
    FOUND: 302,
    NOT_MODIFIED: 304,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    METHOD_NOT_ALLOWED: 405,
    NOT_ACCEPTABLE: 406,
    CONFLICT: 409,
    GONE: 410,
    PRECONDITION_FAILED: 412,
    PAYLOAD_TOO_LARGE: 413,
    UNPROCESSABLE_ENTITY: 422,
    LOCKED: 423,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500,
    NOT_IMPLEMENTED: 501,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
};
/** Every API path is versioned. The master prompt mandates `/v1`. */
export const API_VERSION = {
    V1: 'v1',
};
export const CURRENT_API_VERSION = API_VERSION.V1;
/** Prefix helper so no route hardcodes the version segment. */
export function versionedPath(path, version = CURRENT_API_VERSION) {
    const normalised = path.startsWith('/') ? path : `/${path}`;
    return `/${version}${normalised}`;
}
//# sourceMappingURL=http.js.map